import Controller, { OnChange, OnClick, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangePatientLocationAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { BarcodeAPI, BarcodeData, ModalService } from '@philips-internal/oswald-ui-components';
import { ChangeEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BrokerService } from '@philips-internal/oswald-ui-core/lib/services/broker-service/broker-service';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services/http-service/http-service';
import { Endpoint } from '../../constants/endpoints';
import { ToastMsgUtils } from '../../utils/toastmsg-utils';
import { ApplicationRoute } from '../../constants/routes';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context/data-context';
import { ChangePatientData, changePatientData } from '../../interfaces/change-patient/change-patient-data';

@Controller({ component: ChangePatientLocationAliases.LAYOUT_TROCA_LOCAL_INFO, fragment: FragmentNames.CHANGE_PATIENT_LOCATION })
export default class PatientDisplacmentChangeLocationController extends BaseController {

  @OnClick({ target: ChangePatientLocationAliases.CANCELAR_BUTTON })
  onClickCancel(): void {
    applicationContext.popNavigationItem();
  }

  @OnChange({ target: ChangePatientLocationAliases.AUTOCOMPLETE_DEPARTMENTS})
  async onChangeTextArea(event: ChangeEvent<Record<string, string>>): Promise<void> {
    if (event.value === null) {
      return;
    }
    const unidade = event.value.cdBarras;
    const nrSequencia = event.value.nrSequencia;
    changePatientData.isPatientDisplacement = true;
    try {
      const resp = await HttpService.get(Endpoint.GET_UNITS_AVAILIABLE, {
        unitId: unidade,
      });
      const body = resp.body as { dsLocal: string; nrSequencia: string }[];
      let index = 0;
      body.forEach((element) => {
        if (element.nrSequencia === nrSequencia) {
          index = body.indexOf(element);
        }
      });
      const data = body[index] as ChangePatientData;
      const route = ApplicationRoute.CHANGE_PATIENT_CONFIRMATION;
      applicationContext.redirect(route);
      BrokerService.subscribeToTopic(
        'setChangeData',
        (context: DataContext) => { context.set({ changeData: data }); }
      );
      ModalService.close('change-patient-location');
    } catch (error) {
      ToastMsgUtils.toastErrorMessage('tws.error-generic', 'text.contact_system_admin');
    }
  }

  @OnReadSuccess({ target: ChangePatientLocationAliases.BARCODE_COMPONENT_LOCAL_PA })
  async onReadSuccess(event: ReadEvent<BarcodeData>): Promise<void> {
    const barcode = event.target as BarcodeAPI;
    const route = ApplicationRoute.CHANGE_PATIENT_CONFIRMATION;

    BrokerService.publishToTopic('setInformationBarData', this.context);
    const procParams = {
      unitId: event.item.value.trim()
    }

    barcode.setEnabled(false);
    try {
      const response = await HttpService.get(Endpoint.GET_UNITS_AVAILIABLE, procParams);
      const isValidResponse = Array.isArray(response.body) && response.body.length > 0;
      if (!isValidResponse) {
        barcode.setEnabled(true);
        ToastMsgUtils.toastErrorMessage('text.message-alert-attention', 'text.unit_not_found');
        return;
      }
      const body = response.body as { dsLocal: string; nrSequencia: string } [];
      const data = body[0] as ChangePatientData;
      changePatientData.isPatientDisplacement = true;
      applicationContext.redirect(route);
      BrokerService.subscribeToTopic(
        'setChangeData',
        (context: DataContext) => {
          context.set({ changeData: data });
        }
      );
      ModalService.close('change-patient-location');
    } catch (err) {
      ToastMsgUtils.toastErrorMessage('tws.error-generic', 'text.contact_system_admin');
      barcode.setEnabled(true);
      applicationContext.popNavigationItem();
    }
  }
}
